<template>
    <ShowControl  :title="title" ref="showControl">
    <div style="margin-top: 2%;width: 90%;">
        <div style="width: 100%;height: 90%;">
        <el-table :data="CommentList"
                  style="width: 100%;height: 100%;"
                  empty-text="暂无数据"
                  v-loading="loding">
          <el-table-column prop="title"
                           label="知识点标题"
                           align="center">
          </el-table-column>
          <el-table-column prop="realName"
                           label="老师"
                           align="center">
          </el-table-column>
          <el-table-column prop="knowledgeTypeID"
                           label="知识点类型"
                           align="center">
                    <template #default="scope">
                    <span>{{ Global.KnowledgeTypeList.filter(c=>c.value == scope.row.knowledgeTypeID)[0].name}}</span>
                    </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope">
              <el-button type="primary"
                        @click="KnowledgeClick(scope.row)">查看详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
    </div>
    <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="from.currentPage"
                       :page-sizes="[5, 10, 15, 20]"
                       :page-size="from.pagesize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="Total"
                       style="display: flex; justify-content: center; margin-top: 10px">
    </el-pagination>
        </div>
   </ShowControl>
</template>
    <script>
  import { mapState } from "vuex";
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    components: { ShowControl },
    data () {
      return {
        loding: false,
        from:{
            currentPage:1,
            pagesize: 15
        },
        CommentList: [],
        Total: 0,
        title: '我的收藏',
      };
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow:(state) => state.user.chatShows,
      }),
    },
    created () {
      this.GetCommentsList();
    },
    methods: {
    KnowledgeClick(row){
      this.$router.push({ path: '/KnowledgeControl', query: {id : row.knowledgeTypeID, kid: row.id}});
    },
    handleSizeChange: function (size) {
      this.from.pagesize = size;
      this.GetAchievementsAll();
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.from.currentPage = currentPage;
      this.GetAchievementsAll();
    },
    GetCommentsList () {
          this.loding = true; 
          try {
            // 创建 XMLHttpRequest 对象
            const xhr = new XMLHttpRequest();
            // 设置请求的 URL
            xhr.open("POST", this.Global.knowledgeurl + `api/Knowledge/GetCommentsList`, true);
            // 设置响应类型为 text/event-stream
            xhr.setRequestHeader("Content-Type", "application/json");
            // 监听 readyStateChange 事件
            xhr.onreadystatechange = () => {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  this.CommentList = JSON.parse(xhr.responseText).dynamicObj
                  this.loding = false;
                }
              }
            };
            xhr.send(
              JSON.stringify({
                currentPage: this.from.currentPage,
                pagesize: this.from.pagesize,
                userId: parseInt(localStorage.getItem("userId")),
                id: this.Global.ProjectType.会展项目
              })
            );
          } catch (error) {
            this.loding = false;
          }
        },
    }
  };
    </script>
    
    <style scoped>
  </style>